import { createRoleGuard } from './create-role-guard'

export const adminGuard = createRoleGuard((role) => role === 'ADMIN' || role === 'SUPPORT')
